import { Component } from 'opus-angular-seed-core';
import {
    PREVIEW_EXCEPTION_KEYS,
    getApplicablePreviewExceptions,
    isLinearChapterNavigation
} from '../../../../services/authoringTool/previewExceptions';

@Component({
    bindings: {
        materialSubmission: '=',
        viewOnly: '=',
        viewMode: '=',
        company: '=',
        material: '=',
        previewLoading: '=',
        course: '=',
        initMode: '<',
        onCloseModal: '<',
        isEditorViewGenerated: '<',
        // learner rules are not enforced in the admin preview, see services/authoringTool/previewExceptions
        isAdminPreview: '<'
    },
    template: `
        <div class="authoring-tool-container" ng-class="{ active: vm.isMenuActive }">
            <div class="topbar">
                <div class="burger ico-menu" ng-click="vm.toggleMenu()"></div>
                <div class="middle-content">
                    <div class="preview-exception-notices" ng-if="vm.previewExceptions.length">
                        <div
                            ng-repeat="exception in vm.previewExceptions track by exception.key"
                            class="alert alert-warn ico-alert preview-exception-notice"
                        >
                            <p>{{ exception.messageKey | translate }}</p>
                        </div>
                    </div>
                    <h1 class="authoring-tool-title">{{ vm.materialSubmission.occurrenceTraining.training.activeI18n.name }}</h1>
                    <div class="progress-edit-wrapper">
                        <div class="progress-wrapper">
                            <progress value="{{ vm.getProgressPercentage() }}" max="100" />
                            <label>{{ 'materials.Completed' | translate }} {{ vm.getProgressPercentage() }}%</label>
                        </div>
                        <button
                            ng-if="vm.viewMode === 'preview' && !vm.course.isArchived"
                            class="btn bordered02 edit-button"
                            ng-class="{'loading':vm.previewLoading}"
                            ng-disabled="vm.previewLoading"
                            ng-click="vm.initEditorMode()">
                                {{ 'general.Edit' | translate }}
                        </button>
                    </div>
                </div>
                <div class="close-icon" ng-click="vm.closeModal()"></div>
            </div>
            <div class="materials-wrapper">
                <div class="sidebar">
                    <div class="sidebar-heading">
                        <h3>{{ 'course.materialSource.Chapters' | translate }}</h3>
                        <div class="sidebar-toggle ico-arrow-left-to-line" ng-click="vm.toggleMenu()"></div>
                    </div>
                    <div class="sidebar-content">
                        <ul class="chapter-list">
                            <li ng-repeat="item in vm.chaptersWithSections">
                                <details
                                    ng-if="item.type === 'section'"
                                    class="section-item"
                                    ng-open="vm.isCurrentChapterInSection(item)"
                                >
                                    <summary
                                        class="section-toggle"
                                        ng-class="{ completed: vm.isCompleted(item) }"
                                    >
                                        <div class="icon ico-arrow-right03"></div>  {{ item.name }}
                                    </summary>
                                    <ul>
                                        <li ng-repeat="chapterInSection in item.chapters">
                                            <div
                                                class="chapter-item"
                                                ng-class="{
                                                    completed: vm.isCompleted(chapterInSection),
                                                    current: vm.isCurrentChapter(chapterInSection),
                                                    locked: !vm.isChapterAccessible(chapterInSection.index)
                                                }"
                                                ng-attr-title="{{ vm.chapterTooltip(chapterInSection.index) }}"
                                                ng-click="vm.onChapterClick(chapterInSection.index)"
                                            >
                                                <span
                                                    class="material-chapter-status-icon"
                                                    ng-class="{ 'ico-check2': vm.isCompleted(chapterInSection) }"
                                                ></span>
                                                <span>{{ chapterInSection.name }}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </details>
                                <div
                                    ng-if="item.type === 'chapter'"
                                    class="chapter-item"
                                    ng-class="{completed: vm.isCompleted(item), current: vm.isCurrentChapter(item), locked: !vm.isChapterAccessible(item.index)}"
                                    ng-attr-title="{{ vm.chapterTooltip(item.index) }}"
                                    ng-click="vm.onChapterClick(item.index)"
                                >
                                    <span class="material-chapter-status-icon" ng-class="{'ico-check2': vm.isCompleted(item)}"></span>
                                    <span>{{ item.name }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content">
                    <div class="content-panel">
                        <div class="content-container">
                            <div ng-bind-html="trustedHtml(vm.getCurrentChapterContent())"></div>
                        </div>
                    </div>
                    <div class="content-footer">
                        <button
                            ng-if="vm.isPreviousChapterExist()"
                            class="secondary-button"
                            ng-click="vm.previous()"
                            type="button"
                        >
                            {{ 'general.Previous' | translate }}
                        </button>
                        <button
                            ng-if="!vm.isCompleteButton()"
                            class="main-button"
                            ng-click="vm.next()"
                            ng-class="{ loading: vm.loading }"
                            ng-disabled="vm.loading"
                            type="button"
                        >
                            {{ 'materials.Next' | translate }}
                        </button>
                        <button
                            ng-if="vm.isCompleteButton()"
                            class="main-button"
                            ng-click="vm.finish()"
                            ng-class="{ loading: vm.loading }"
                            ng-disabled="vm.loading"
                            type="button"
                        >
                            {{ 'materials.Complete' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <style>
            .chapter-item.locked {
                opacity: 0.45;
                cursor: not-allowed;
            }
            .preview-exception-notices {
                display: flex;
                flex-direction: column;
                gap: 4px;
                flex: 0 1 auto;
                min-width: 0;
                margin-right: auto;
            }
            .preview-exception-notice {
                display: flex;
                align-items: center;
                position: relative;
                margin: 0;
                padding: 6px 12px;
                font-size: 13px;
            }
            /* scoped to win over the generic .alert:not(.has-icon):before icon size and offset */
            .authoring-tool-container .preview-exception-notice.alert::before {
                position: static;
                top: auto;
                flex: 0 0 auto;
                margin-right: 8px;
                font-size: 16px;
                line-height: 1;
            }
            .preview-exception-notice p {
                margin: 0;
            }
        </style>
    `
})
export default class {
    constructor (
        lodash,
        MaterialSubmissionResource,
        FormFactory,
        toastr,
        $translate,
        $scope,
        $rootScope,
        $sce,
        TokenService,
        $element,
        $window,
        OccurrenceResource,
        $interval,
        COURSE_PROGRESS_STATUS_TYPE_ENUM
    ) {
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;
        this.$interval = $interval;
        this.lodash = lodash;
        this.MaterialSubmissionResource = MaterialSubmissionResource;
        this.OccurrenceResource = OccurrenceResource;
        this.FormFactory = FormFactory;
        this.toastr = toastr;
        this.$translate = $translate;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.TokenService = TokenService;
        this.$element = $element;
        this.$window = $window;
        this.userAgent = $window.navigator.userAgent;
        this.isMobile =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                this.userAgent
            );

        this.isMenuActive = !this.isMobile;

        $scope.trustedHtml = function (plainText) {
            if (plainText) {
                // Add !important to video inline width to override compiled CSS rule
                plainText = plainText.replace(
                    /(<video[^>]*style="[^"]*?)width:\s*([^;"!]+)(;?)/gi,
                    '$1width: $2 !important$3'
                );
            }
            return $sce.trustAsHtml(plainText);
        };

        this.inFrame = self !== top;
        this.token = null;

        this.chaptersRequiresSection = this.generateChaptersRequiresSection(
            this.material
        );
        this.chaptersWithSections = this.getChaptersWithSections(
            this.material.chapters
        );

        addEventListener('message', (e) => {
            if (e.data.token) {
                this.token = e.data.token;
                this.$scope.$apply();
            }

            if (e.data.type === 'material-preview-fullscreen') {
                const outer = $element[0].querySelector(
                    `.material-preview[src="${e.data.src}"]`
                );
                if (outer) {
                    outer.classList.toggle('pfs');
                }
            }
            else if (e.data.type === 'material-preview-exit') {
                const outer = $element[0].querySelector(
                    `.material-preview[src="${e.data.src}"]`
                );
                if (outer) {
                    outer.classList.remove('pfs');
                }
            }
        });

        // Push a new state to the history when the modal is opened.
        // It is needed to prevent "back" action when modal is opened
        history.pushState(null, null, window.location.href);

        // When browser "back" button is clicked
        window.onpopstate = function () {
            this.closeModal();
        }.bind(this);
    }

    $onInit () {
        this.completed = [];
        this.sectionOpenState = {};

        if (this.materialSubmission) {
            this.form = this.FormFactory.createFromResource(
                this.materialSubmission
            );
            this.material = this.materialSubmission.material;
        }
        this.initPreviewExceptions();
        this.setProgress();

        if (this.material && this.material.initialChapter > 0) {
            this.currentChapter = this.material.initialChapter;
        }

        window.parent.postMessage('action:getToken', '*');

        if (this.TokenService.hasToken()) {
            this.token = this.TokenService.token;
        }

        if (this.company) {
            this.initCompanyColorScheme(this.company);
        }

        this.scrollTop();
        this.observeVideos();
        this.observeEmbeddedMedia();
        this.startDeadlineCheck();

        const onEsc = (e) => {
            if (e.key !== 'Escape') return;
            e.stopPropagation();
            const fsIframe = this.$element[0].querySelector('iframe.embed-pfs');
            if (fsIframe) {
                fsIframe.classList.remove('embed-pfs');
                const fsBtn = fsIframe.closest('.media-selected-wrapper') &&
                    fsIframe.closest('.media-selected-wrapper').querySelector('.embed-toolbar-btn');
                if (fsBtn) fsBtn.textContent = this.$translate.instant('general.FullScreen');
            }
        };
        document.addEventListener('keydown', onEsc, true);
        this.$scope.$on('$destroy', () => {
            document.removeEventListener('keydown', onEsc, true);
            this.stopDeadlineCheck();
        });
    }

    toggleMenu () {
        this.isMenuActive = !this.isMenuActive;
    }

    closeModal () {
        if (this.viewMode === 'preview') {
            this.onCloseModal();
            return;
        }

        window.parent.postMessage('action:closeMaterialDialog', '*');
        if (this.viewOnly) {
            this.$rootScope.$broadcast('authoringTool:toEditor');
        }
    }

    getChaptersWithSections (chapters) {
        const chaptersWithSections = [];
        this.lodash.forEach(chapters, (chapter, index) => {
            if (this.isSectionBeforeChapter(chapter)) {
                const section = {
                    type: 'section',
                    index: null,
                    name: chapter.section.name,
                    id: chapter.section.id,
                    uniqueKey: chapter.section.uniqueKey,
                    expanded: true,
                    chapters: []
                };
                chapter.type = 'chapter';
                section.chapters.push(chapter);
                chapter.index = index;
                chaptersWithSections.push(section);
            }
            else if (this.isInSection(chapter)) {
                // eslint-disable-next-line eqeqeq
                const section =
                    chapter.section.id !== null
                        ? this.lodash.find(chaptersWithSections, {
                            type: 'section',
                            id: chapter.section.id
                        })
                        : this.lodash.find(chaptersWithSections, {
                            type: 'section',
                            uniqueKey: chapter.section.uniqueKey
                        });

                chapter.type = 'chapter';
                chapter.index = index;
                section.chapters.push(chapter);
            }
            else {
                chapter.type = 'chapter';
                chapter.index = index;
                chaptersWithSections.push(chapter);
            }
        });

        return chaptersWithSections;
    }

    isInSection (chapter) {
        return chapter.section !== undefined && chapter.section !== null;
    }

    isSectionBeforeChapter (chapter) {
        if (chapter.section === undefined || chapter.section === null) {
            return false;
        }
        return this.chaptersRequiresSection.some(
            (item) => item.hash === chapter.hash
        );
    }

    generateChaptersRequiresSection (material) {
        const chaptersRequiresSection = [];
        this.lodash.forEach(material.chapters, (chapter) => {
            // eslint-disable-next-line eqeqeq
            if (chapter.sectionData != null) {
                chapter.section = chapter.sectionData;
            }
            // eslint-disable-next-line eqeqeq
            if (chapter.section != null) {
                // eslint-disable-next-line eqeqeq
                if (chapter.section.id != null) {
                    if (
                        !chaptersRequiresSection.some(
                            (item) => item.section.id === chapter.section.id
                        )
                    ) {
                        chaptersRequiresSection.push(chapter);
                    }
                }
                else {
                    if (
                        !chaptersRequiresSection.some(
                            (item) =>
                                item.section.uniqueKey ===
                                chapter.section.uniqueKey
                        )
                    ) {
                        chaptersRequiresSection.push(chapter);
                    }
                }
            }
        });
        return chaptersRequiresSection;
    }

    initCompanyColorScheme (company) {
        if (company.brandColor !== null) {
            document.documentElement.style.setProperty(
                '--brand-main',
                company.brandColor
            );
        }
    }

    scrollTop () {
        setTimeout(() => {
            const contentContainer = document.querySelector('.content');
            if (contentContainer) {
                contentContainer.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }, 0);
    }

    scrollBottom () {
        setTimeout(() => {
            const contentContainer = document.querySelector('.content');
            if (contentContainer) {
                contentContainer.scrollTo({
                    top: contentContainer.scrollHeight,
                    behavior: 'smooth'
                });
            }
        }, 0);
    }

    observeVideos () {
        const container = this.$element[0].querySelector('.content-container');
        if (!container) return;

        const initPlyrForNode = (node) => {
            if (node.nodeType !== 1) return;
            const videos = node.id && node.id.startsWith('plyr-player-')
                ? [node]
                : Array.from(node.querySelectorAll('[id^="plyr-player-"]'));
            videos.forEach((video) => {
                if (/^plyr-player-[a-zA-Z]{5}$/.test(video.id) && !video.closest('.plyr')) {
                    // Capture layout styles before Plyr wraps the video
                    const style = video.style;
                    const layoutStyles = {
                        width: style.getPropertyValue('width'),
                        widthPriority: style.getPropertyPriority('width'),
                        height: style.getPropertyValue('height'),
                        maxWidth: style.getPropertyValue('max-width'),
                        display: style.getPropertyValue('display'),
                        float: style.getPropertyValue('float'),
                        marginLeft: style.getPropertyValue('margin-left'),
                        marginRight: style.getPropertyValue('margin-right')
                    };

                    // eslint-disable-next-line no-undef
                    const player = new Plyr(`#${video.id}`, {
                        speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] }
                    });

                    // Transfer layout styles from original video to .plyr wrapper
                    const plyrEl = video.closest('.plyr');
                    if (plyrEl) {
                        // Make .plyr inline-level so it responds to text-align
                        plyrEl.style.display = 'inline-flex';

                        if (layoutStyles.width) {
                            plyrEl.style.setProperty('width', layoutStyles.width, layoutStyles.widthPriority || undefined);
                        }
                        if (layoutStyles.maxWidth) {
                            plyrEl.style.maxWidth = layoutStyles.maxWidth;
                        }
                        if (layoutStyles.float) {
                            plyrEl.style.float = layoutStyles.float;
                        }
                        // Convert margin:auto centering to text-align:center on parent
                        if (layoutStyles.marginLeft === 'auto' && layoutStyles.marginRight === 'auto') {
                            const parent = plyrEl.parentElement;
                            if (parent) parent.style.textAlign = 'center';
                        }

                        // Constrain settings menu height based on actual player size
                        const settingsBtn = plyrEl.querySelector('[data-plyr="settings"]');
                        if (settingsBtn) {
                            settingsBtn.addEventListener('click', () => {
                                requestAnimationFrame(() => {
                                    const inner = plyrEl.querySelector('.plyr__menu__container > div');
                                    if (inner) {
                                        const controlsEl = plyrEl.querySelector('.plyr__controls');
                                        const controlsH = controlsEl ? controlsEl.offsetHeight : 40;
                                        const maxH = Math.max(plyrEl.offsetHeight - controlsH, 80);
                                        inner.style.setProperty('max-height', `${maxH}px`, 'important');
                                        inner.style.setProperty('overflow-y', 'auto', 'important');
                                    }
                                });
                            });
                        }

                        // Capture original video inline dimensions for restore
                        const origVideoWidth = style.getPropertyValue('width');
                        const origVideoWidthPriority = style.getPropertyPriority('width');
                        const origVideoHeight = style.getPropertyValue('height');
                        const origVideoHeightPriority = style.getPropertyPriority('height');

                        // Reset inline styles in fullscreen so video fills the screen
                        player.on('enterfullscreen', () => {
                            plyrEl.style.display = '';
                            plyrEl.style.width = '';
                            plyrEl.style.maxWidth = '';
                            plyrEl.style.float = '';
                            video.style.width = '100%';
                            video.style.height = '100%';
                            video.style.maxWidth = '';
                        });
                        player.on('exitfullscreen', () => {
                            plyrEl.style.display = 'inline-flex';
                            if (layoutStyles.width) {
                                plyrEl.style.setProperty('width', layoutStyles.width, layoutStyles.widthPriority || undefined);
                            }
                            if (layoutStyles.maxWidth) {
                                plyrEl.style.maxWidth = layoutStyles.maxWidth;
                            }
                            if (layoutStyles.float) {
                                plyrEl.style.float = layoutStyles.float;
                            }
                            // Restore original video dimensions
                            if (origVideoWidth) {
                                video.style.setProperty('width', origVideoWidth, origVideoWidthPriority || undefined);
                            }
                            else {
                                video.style.width = '';
                            }
                            if (origVideoHeight) {
                                video.style.setProperty('height', origVideoHeight, origVideoHeightPriority || undefined);
                            }
                            else {
                                video.style.height = '';
                            }
                            video.style.maxWidth = layoutStyles.maxWidth || '';
                        });
                    }
                }
            });
        };

        // Watch for DOM changes (initial render, chapter switches, content updates)
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach(initPlyrForNode);
            });
        });
        observer.observe(container, { childList: true, subtree: true });

        this.$scope.$on('$destroy', () => observer.disconnect());
    }

    observeEmbeddedMedia () {
        const container = this.$element[0].querySelector('.content-container');
        if (!container) return;

        const addFullscreenButton = (wrapper) => {
            if (wrapper.querySelector('.embed-toolbar')) return;

            // Skip material-preview iframes (PDF/PPTX) and H5P — they have their own fullscreen
            const iframe = wrapper.querySelector('iframe');
            if (!iframe || iframe.classList.contains('material-preview')) return;
            const iframeSrc = iframe.src || '';
            if (/\/h5p\/embed\//i.test(iframeSrc)) return;
            if (/h5p_embed/i.test(iframeSrc)) return;

            iframe.setAttribute('allowfullscreen', 'true');
            iframe.setAttribute('allow', 'fullscreen');

            const fullScreenLabel = this.$translate.instant('general.FullScreen');
            const exitFullScreenLabel = this.$translate.instant('general.ExitFullScreen');

            const btn = document.createElement('button');
            btn.className = 'embed-toolbar-btn';
            btn.title = fullScreenLabel;
            btn.textContent = fullScreenLabel;

            const exitFullscreen = () => {
                iframe.classList.remove('embed-pfs');
                btn.textContent = fullScreenLabel;
            };

            btn.addEventListener('click', () => {
                if (iframe.classList.contains('embed-pfs')) {
                    exitFullscreen();
                }
                else {
                    iframe.classList.add('embed-pfs');
                    btn.textContent = exitFullScreenLabel;
                }
            });

            const toolbar = document.createElement('div');
            toolbar.className = 'embed-toolbar';
            toolbar.appendChild(btn);
            wrapper.insertBefore(toolbar, wrapper.firstChild);
        };

        const processNode = (node) => {
            if (node.nodeType !== 1) return;
            const wrappers = node.classList && node.classList.contains('media-selected-wrapper')
                ? [node]
                : Array.from(node.querySelectorAll('figure.media-selected-wrapper'));
            wrappers.forEach(addFullscreenButton);
        };

        // Process already-rendered content
        container.querySelectorAll('figure.media-selected-wrapper').forEach(addFullscreenButton);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach(processNode);
            });
        });
        observer.observe(container, { childList: true, subtree: true });

        this.$scope.$on('$destroy', () => observer.disconnect());
    }

    getCurrentChapterContent () {
        const content = this.getCurrentChapter()
            ? this.getCurrentChapter().content
            : null;

        if (this.token) {
            return this.parseContent(content);
        }

        return content;
    }

    getCurrentChapter () {
        return this.material.chapters.length
            ? this.material.chapters[this.currentChapter]
            : null;
    }

    /**
     * Returns true when:
     * 1) all chapters are finished
     * 2) you are on the last incompleted chapter
     */
    isCompleteButton () {
        if (this.getTotalCompleted() === this.material.chapters.length) {
            return true;
        }
        if (
            this.getTotalCompleted() + 1 === this.material.chapters.length &&
            this.completed[this.currentChapter] === false
        ) {
            return true;
        }

        return false;
    }

    isNextChapterExist () {
        return this.currentChapter + 2 <= this.material.chapters.length;
    }

    isPreviousChapterExist () {
        return this.currentChapter > 0;
    }

    setChapter (index) {
        this.currentChapter = index;
    }

    onChapterClick (index) {
        if (!this.isChapterAccessible(index)) {
            return;
        }
        if (this.isMobile) {
            this.toggleMenu();
        }
        this.setChapter(index);
        this.scrollTop();
    }

    initPreviewExceptions () {
        this.previewExceptions = this.isAdminPreview === true
            ? getApplicablePreviewExceptions(this.material)
            : [];
    }

    isPreviewExceptionActive (key) {
        return this.previewExceptions.some(exception => exception.key === key);
    }

    /**
     * Returns true when the material is configured for linear chapter navigation
     */
    isLinearNavigation () {
        return isLinearChapterNavigation(this.material);
    }

    /**
     * In linear mode a chapter can only be opened when every preceding chapter is completed.
     * In free mode, and in the admin preview, every chapter is always accessible.
     */
    isChapterAccessible (index) {
        if (!this.isLinearNavigation() || this.isPreviewExceptionActive(PREVIEW_EXCEPTION_KEYS.CHAPTER_NAVIGATION)) {
            return true;
        }
        if (index <= 0) {
            return true;
        }
        for (let i = 0; i < index; i++) {
            if (this.completed[i] !== true) {
                return false;
            }
        }
        return true;
    }

    /**
     * Returns the tooltip shown when hovering a locked (inaccessible) chapter.
     * Empty string for accessible chapters so no tooltip is displayed.
     */
    chapterTooltip (index) {
        if (this.isChapterAccessible(index)) {
            return '';
        }
        return this.$translate.instant('authoringTool.Chapters need to be completed in set order');
    }

    isCurrentChapter (item) {
        return this.currentChapter === item.index;
    }

    isCurrentChapterInSection (section) {
        return section.chapters.some((chapter) =>
            this.isCurrentChapter(chapter)
        );
    }

    isCompleted (item) {
        if (item.type === 'chapter') {
            return this.completed[item.index] === true;
        }
        if (item.type === 'section') {
            const total = item.chapters.length;
            let completed = 0;
            this.lodash.forEach(item.chapters, (chapter) => {
                if (this.isCompleted(chapter)) {
                    completed++;
                }
            });
            return total === completed;
        }
        return false;
    }

    getTotalCompleted () {
        let total = 0;
        this.lodash.forEach(this.completed, (isCompleted) => {
            if (isCompleted) total++;
        });
        return total;
    }

    next () {
        this.loading = true;
        this.completed[this.currentChapter] = true;

        if (this.isNextChapterExist()) {
            this.setChapter(this.currentChapter + 1);
        }
        else {
            this.currentChapter = 0;
            this.setChapter(0);
        }

        this.markProgress();
        this.scrollTop();
    }

    finish () {
        if (this.isEditorViewGenerated) {
            this.initEditorMode();
            return;
        }

        this.loading = true;
        this.completed[this.currentChapter] = true;
        this.markProgress(true);
    }

    close () {
        parent.postMessage('closeMaterialOverlay()', '*');
        if (this.viewOnly) {
            this.$rootScope.$broadcast('authoringTool:toEditor');
        }
    }

    previous () {
        this.setChapter(this.currentChapter - 1);
        this.scrollBottom();
    }

    getProgressPercentage () {
        if (!this.material.chapters.length) {
            return 0;
        }

        return Math.round(
            (this.getTotalCompleted() / this.material.chapters.length) * 100
        );
    }

    setProgress () {
        this.currentChapter = 0;

        // set this.completed taken from materialSubmission
        if (
            this.materialSubmission &&
            this.materialSubmission.completion !== undefined &&
            this.materialSubmission.completion &&
            this.materialSubmission.completion.length
        ) {
            const progress = JSON.parse(this.materialSubmission.completion);
            this.completed = progress.chapters;
            let isChapterChanged = false;
            this.completed.forEach((isCompleted, index) => {
                if (!isCompleted && !isChapterChanged) {
                    this.currentChapter = index;
                    isChapterChanged = true;
                }
            });
        }
        else {
            this.lodash.forEach(this.material.chapters, (chapter, index) => {
                this.completed[index] = false;
            });
        }
    }

    markProgress (close = false) {
        if (this.viewOnly) {
            this.loading = false;
            if (close) {
                this.closeModal();
            }
            return;
        }

        // On every action triggered during training, check the occurrence training deadline first.
        // If it is overdue, the training is marked NOT_PASSED on the backend and we stop here.
        this.handleOverdueDeadline().then((isNotPassed) => {
            if (isNotPassed) {
                this.stopDeadlineCheck();
                this.loading = false;
                this.toastr.error(
                    this.$translate.instant('materials.Failed to pass the course before the deadline')
                );
                setTimeout(() => {
                    this.closeModal();
                }, 2000);
                return;
            }
            this.saveProgress(close);
        });
    }

    handleOverdueDeadline () {
        return this.OccurrenceResource.handleOverdueDeadline(
            {},
            {
                guid: this.materialSubmission.guid,
                materialType: this.materialSubmission.occurrenceTraining.training.materialType,
                occurrenceTrainingId: this.materialSubmission.occurrenceTraining.id
            }
        ).$promise.then((response) => response.status === this.COURSE_PROGRESS_STATUS_TYPE_ENUM.KEYS.NOT_PASSED);
    }

    saveProgress (close = false) {
        const completion = { chapters: this.completed };
        this.form.model.completion = completion;
        this.MaterialSubmissionResource.update(
            {
                guid: this.materialSubmission.guid,
                expand: 'material.chapters,occurrenceTraining.training.activeI18n'
            },
            this.form.model
        )
        .$promise.then(() => {
            this.loading = false;
            if (close) {
                this.stopDeadlineCheck();
            }
            if (close && !this.viewOnly) {
                this.toastr.success(
                    this.$translate.instant('materials.Completed successfully')
                );
            }
            if (close) {
                setTimeout(() => {
                    this.closeModal();
                }, 2000);
            }
        })
        .catch((e) => {
            console.error(e);
            this.loading = false;
            if (this.isCompleteButton()) {
                if (e.data) {
                    this.toastr.error(
                        this.$translate.instant(e.data[0].message)
                    );
                    setTimeout(() => {
                        this.closeModal();
                    }, 2000);
                }
            }
        });
    }
    parseContent (content) {
        if (!content || !this.token) return content || '';

        // Add jwt to EVERY H5P iframe src that lacks it (no other changes)
        return content.replace(
            /(<iframe\b[^>]*\bsrc=")([^"]*action=h5p_embed[^"]*)(")/g,
            (full, pre, src, post) => {
                if (/[?&]jwt=/.test(src)) return full; // already has jwt
                const sep = src.includes('?') ? '&' : '?';
                return `${pre}${src}${sep}jwt=${encodeURIComponent(
                    this.token
                )}${post}`;
            }
        );
    }

    startDeadlineCheck () {
        if (this.viewOnly || !this.materialSubmission) {
            return;
        }

        this.deadlineCheckInterval = this.$interval(() => {
            this.handleOverdueDeadline().then((isNotPassed) => {
                if (isNotPassed) {
                    this.stopDeadlineCheck();
                    this.toastr.error(
                        this.$translate.instant('materials.Failed to pass the course before the deadline')
                    );
                    setTimeout(() => {
                        this.closeModal();
                    }, 2000);
                }
            });
        }, 60000);
    }

    stopDeadlineCheck () {
        if (this.deadlineCheckInterval) {
            this.$interval.cancel(this.deadlineCheckInterval);
            this.deadlineCheckInterval = null;
        }
    }

    initEditorMode () {
        this.initMode('editor');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/authoringTool/view/index.js